import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { useEntities } from "@hooks/useEntities";
import { useUser } from "@hooks/useUser";

export function usePrimaryEntity() {
    const activeWorkspace = useActiveWorkspace();
    const user = useUser();
    const entitiesInWorkspace = useEntities();

    if (!user || !activeWorkspace) {
        return null;
    }

    const isOwnWorkspace = activeWorkspace.primaryAdminUserId === user.id;

    // Pick first business entity the user has access too (normal flow, normal invite)
    // Alternatively, pick a personal entity (odd case, where user has been invited to a workspace, but only to the personal entity)

    if (isOwnWorkspace) {
        return entitiesInWorkspace.find((e) => e.isBusiness) ?? null;
    } else {
        return (
            entitiesInWorkspace.find((e) => e.isBusiness) ??
            entitiesInWorkspace.find((e) => e.isPersonal) ??
            null
        );
    }
}
